import Vue from 'vue';
import Vuetify, {
	VStepper,
	VCard,
	VBtn,
	VApp,
	VAppBar,
} from 'vuetify/lib';

Vue.use(Vuetify, {
	components: {
		VStepper,
		VCard,
		VBtn,
		VApp,
		VAppBar,
	}
});

export default new Vuetify({
	theme: {
    themes: {
      light: {
        primary: '#0f3152',
        // primary35: '#6777B0',
        secondary: '#38c68b',
        accent: '#2A2122',
        gris: '#928F90',
      },
    },
  },
});
